import { render, staticRenderFns } from "./FormProductFileComponent.vue?vue&type=template&id=2cb99760&scoped=true"
import script from "./FormProductFileComponent.vue?vue&type=script&lang=js"
export * from "./FormProductFileComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductFileComponent.vue?vue&type=style&index=0&id=2cb99760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb99760",
  null
  
)

export default component.exports